import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/foretag";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/business")(
  enRouteOptions(routeOptions, {
    svPath: "/foretag",
    title: 'For Businesses – Team Licences for Staff Training',
    description: 'Train your whole team for the Swedish alcohol serving licence test. Volume licences, invoicing and progress overview.',
    ogImage: "https://alkoholprovet.se/og/default.jpg",
    noindex: false,
  }),
);
